import { render, staticRenderFns } from "./HeaderBreadcrumbs.vue?vue&type=template&id=3b672c88"
import script from "./HeaderBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./HeaderBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports